/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : FormStepper.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Configure Steps Stepper component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date         : Dec 29, 2021
 *
 * @Version      : Version 1.0
 *
 * By            :
 * On            :
 * Description   :
 *
 *
 ******************************************************************************/

import React, { FC } from "react";
import { Stepper } from "@scuf/common";
import { IFormStepperProps } from "./IFormStepperProps";
import "./FormStepper.scss";

export const FormStepper: FC<IFormStepperProps> = ({ currentStep }) => {
  return (
    <div className="stepper-wrapper">
      <Stepper ordered={true} data-testid="formStepperTest" fluid={true}>
        <Stepper.Item
          title="General Info"
          active={currentStep === 1}
          completed={currentStep !== 1 && currentStep > 1}
        />

        <Stepper.Item
          title="Select APM File"
          active={currentStep === 2}
          completed={currentStep !== 2 && currentStep > 2}
        />
        <Stepper.Item
          title="Aircraft Details"
          active={currentStep === 3}
          completed={currentStep !== 3 && currentStep > 3}
        />
        <Stepper.Item
          title="APM Settings"
          active={currentStep === 4}
          completed={currentStep !== 4 && currentStep > 4}
        />
      </Stepper>
    </div>
  );
};
